export function resolveApiBase(): string {
  const envApiURL = process.env.REACT_APP_AI_API;
  const currentApiURL = `${window.location.origin}/api`;
  return currentApiURL.match(/advon\.ai|getsupermodel\.ai/) ? currentApiURL : envApiURL;
}
